var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEnLang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EN",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 18.25,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_14881",
    "data-name": "Path 14881",
    d: "M3.542-10.739v3.923H8.158v1.789H3.542v4.1H8.735V.858H1.35V-12.528H8.735v1.789Zm13.232.827a4.752,4.752,0,0,1,2.241.519,3.693,3.693,0,0,1,1.548,1.539,5.061,5.061,0,0,1,.558,2.462V.858H18.947V-5.066a3.076,3.076,0,0,0-.712-2.183,2.533,2.533,0,0,0-1.942-.76,2.564,2.564,0,0,0-1.952.76,3.05,3.05,0,0,0-.721,2.183V.858H11.428v-10.6H13.62v1.212A3.629,3.629,0,0,1,15-9.547,4.4,4.4,0,0,1,16.774-9.912Z",
    transform: "translate(6.367 23.571)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnLang);
export default __webpack_public_path__ + "static/media/icon-en-lang.6f5c6a6682c369c06159f35e7925605a.svg";
export { ForwardRef as ReactComponent };